import { connect } from "react-redux";
import moment from "moment";
import { setSuccessNotification } from "./actions/notifications";
import Invoice from "./Invoice";
import html2pdf from "html2pdf.js";

const mapStateToProps = state => state.modalForm.createInvoice;

const mapDispatchToProps = dispatch => {
  return {
    toString(invoiceNumber = "") {
      let invoiceCopy = document.getElementById("Invoice").cloneNode(true);
      invoiceCopy.classList.add("print");
      const invoiceNumberString =
        invoiceNumber.length > 0 ? "_" + invoiceNumber.toString() : "";
      const filename = `conductor_invoice${invoiceNumberString}_${moment().format(
        "YYYYMMDD"
      )}.pdf`;
      invoiceCopy.getElementsByClassName("hide")[0].remove();
      dispatch(setSuccessNotification(`Downloading ${filename}`));
      window.setTimeout(() => {
        html2pdf(invoiceCopy, {
          filename,
          html2canvas: { dpi: 192, letterRendering: true },
          jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
        });
      });
    }
  };
};
const connectedInvoice = connect(mapStateToProps, mapDispatchToProps)(Invoice);

export default connectedInvoice;



// WEBPACK FOOTER //
// ./src/InvoiceContainer.js